import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import FormCad from '../../../../components/auth/contratos/form_cad'


function CadastrarContratoScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Contrato" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarContratoScreen;